export default __webpack_public_path__ + "static/media/banner.9f068a63.jpeg";